// extracted by mini-css-extract-plugin
module.exports = {"viewToggleBox":"viewToggleBox_3vN-F","boxContentWrapper":"boxContentWrapper_JbwNb","iconMobile":"iconMobile_2dIdK","iconDesktop":"iconDesktop_1wiwa"};